<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-2">
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('productGroup.category') }}</label>
            <a-select 
              v-model="model.category_id"
              :options="catOptions"
              showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
              class="ts-w-full"
            ></a-select>
            <div
              class="validate ts-text-xs"
              v-if="errors.has('category_id')"
            >{{ errors.first('category_id') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('productGroup.nameKh') }}</label>
            <input
              v-model="model.pro_group_name_kh"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('pro_group_name_kh') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('pro_group_name_kh')"
            >{{ errors.first('pro_group_name_kh') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{ $t('productGroup.nameEn') }}</label>
            <input
              v-model="model.pro_group_name_en"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('pro_group_name_en') }"
            />
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('pro_group_name_en')"
            >{{ errors.first('pro_group_name_en') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('productGroup.icon') }}</label>
            <input
              v-model="model.icon"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('icon') }"
            />
            <small><i><a href="https://fontawesome.com/v4.7/icons/" target="_blank">{{ $t('productGroup.findYourIcon') }}</a></i></small>
            <div
              class="invalid-feedback ts-text-xs"
              v-if="errors.has('icon')"
            >{{ errors.first('icon') }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-mt-3 text-right">
            <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
              {{
              $t('cancel')
              }}
            </ts-button>
            <ts-button
              v-if="!isUpdate"
              color="primary"
              @click.prevent="onSave"
              :waiting="waiting"
            >{{ $t('save') }}</ts-button>
            <ts-button
              v-if="isUpdate"
              color="primary"
              @click.prevent="onUpdate"
              :waiting="waiting"
            >{{ $t('update') }}</ts-button>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'productGroupForm',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      loading: false,
      model: {
        pro_group_id: 0,
        category_id: null,
        pro_group_name_kh: null,
        pro_group_name_en: null,
        icon: null
      }
    }
  },
  created() {
    this.setEditData()
    this.fetchData()
  },
  computed: {
    ...mapState('product/group', ['edit_data', 'categories']),
    catOptions(){
      return this.categories.map(el => ({
        value: el.category_id,
        label: el.category_name_en
      }))
    },
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    }
  },
  methods: {
    onSave() {
      this.waiting = true
      this.$store
        .dispatch('product/group/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('product/group/update', {
          id: this.model.pro_group_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    fetchData(){
      this.loading = true
      this.$store.dispatch('product/group/getCategory')
        .finally(() => {
          this.loading = false
        })
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.pro_group_id = this.edit_data.pro_group_id
        this.model.category_id = this.edit_data.category_id
        this.model.pro_group_name_kh = this.edit_data.pro_group_name_kh
        this.model.pro_group_name_en = this.edit_data.pro_group_name_en
        this.model.icon = this.edit_data.icon
      }
    }
  }
}
</script>
